import { type ComponentPropsWithoutRef } from 'react'
import Markdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

const REMARK_PLUGINS = [remarkGfm]

const COMPONENTS: Components = {
  a: ({ node: _node, ...props }: ComponentPropsWithoutRef<'a'> & { node?: unknown }) => (
    <a {...props} target="_blank" rel="noopener noreferrer" />
  ),
}

/** A timeline event's Markdown text: the sentence posted to Slack, links and all. */
export function EventNotes({ notes }: { notes: string }) {
  return (
    <div className="prose prose-sm prose-p:my-0 prose-blockquote:my-1 prose-ul:my-1 prose-li:my-0 prose-a:text-ink mt-2 max-w-none [&_p]:whitespace-pre-line [&_p+p]:mt-3 [&_ul+p]:mt-3">
      <Markdown remarkPlugins={REMARK_PLUGINS} components={COMPONENTS}>
        {notes}
      </Markdown>
    </div>
  )
}
